import { array, boolean, enum as enumFactory, iso, lazySchema, number, strictObject, string } from "../../lazy-zod.js";
import { openMeldRequestContextSchema } from "../daemon/profile-identity.js";
import { daemonServiceLaneSchema } from "../daemon/service-contract.js";
import { START_BOUNDED_ID_SCHEMA } from "../start/shared.js";
import { computerFileAccessUpdateRequestSchema } from "../daemon/computer-file-access.js";
import { localFolderPickerRequestSchema } from "../daemon/local-folder-picker.js";
import { localProjectControlDiscoverProjectsRpcInputSchema } from "../daemon/local-project-control.js";
import { daemonExecutionCompatibilitySchema } from "../daemon/runtime-transport.js";
import { localRuntimeComputerSchema } from "./local-runtimes.js";
//#region src/schemas/http/people-computers.ts
const peopleComputerTargetSchema = strictObject({
	deviceId: START_BOUNDED_ID_SCHEMA,
	runtimeLane: daemonServiceLaneSchema
});
const peopleComputerProjectDiscoveryRpcInputSchema = lazySchema(() => localProjectControlDiscoverProjectsRpcInputSchema.extend(peopleComputerTargetSchema.shape));
const peopleComputerFileAccessReadRpcInputSchema = peopleComputerTargetSchema.extend({ context: openMeldRequestContextSchema });
const peopleComputerFolderPickerBodySchema = localFolderPickerRequestSchema.omit({ expectedDeviceId: true });
const peopleComputerFolderPickerRpcInputSchema = lazySchema(() => peopleComputerTargetSchema.extend({
	context: openMeldRequestContextSchema,
	...peopleComputerFolderPickerBodySchema.shape
}));
const peopleComputerFileAccessUpdateBodySchema = computerFileAccessUpdateRequestSchema.omit({ expectedDeviceId: true });
const peopleComputerFileAccessUpdateRpcInputSchema = lazySchema(() => peopleComputerFileAccessReadRpcInputSchema.extend(peopleComputerFileAccessUpdateBodySchema.shape));
const peopleComputerConnectionSchema = strictObject({
	status: enumFactory([
		"connected",
		"disconnected",
		"unknown"
	]),
	reasonCodes: array(string().min(1).max(256)),
	sessions: array(peopleComputerTargetSchema.extend({
		lastHeartbeatMs: number().int().nonnegative(),
		serviceVersion: string().nullable(),
		executionCompatibility: daemonExecutionCompatibilitySchema,
		controls: strictObject({
			localAgentControl: strictObject({
				refreshCatalog: boolean(),
				setEnabled: boolean(),
				manageInstallations: boolean(),
				manageInstallationsSafely: boolean(),
				setProfileWorkspace: boolean()
			}),
			openMeldToolsControl: strictObject({
				requestUpdate: boolean(),
				setAutomaticUpdates: boolean()
			}),
			computerFileAccess: strictObject({
				readPolicy: boolean(),
				updatePolicy: boolean()
			}).optional(),
			localFolderPicker: strictObject({ selectFolders: boolean() }).optional(),
			localProjectControl: strictObject({ discoverProjects: boolean() }).optional()
		}).optional(),
		serviceUpdate: strictObject({
			wakeBlocked: boolean(),
			reasonCodes: array(string())
		})
	}))
});
const peopleComputerSchema = lazySchema(() => localRuntimeComputerSchema.omit({
	connectionStatus: true,
	isCurrent: true,
	executionTargets: true
}).extend({
	identityStatus: enumFactory(["enrolled", "unconfirmed"]),
	connection: peopleComputerConnectionSchema,
	executionTargets: array(localRuntimeComputerSchema.shape.executionTargets.element.omit({ isCurrent: true }))
}));
const peopleComputersResponseSchema = strictObject({
	generatedAt: iso.datetime({ offset: true }),
	computers: array(peopleComputerSchema)
});
const peopleComputerCliInventorySchema = peopleComputersResponseSchema.extend({ computers: array(peopleComputerSchema.extend({ isThisComputer: boolean() })) });
//#endregion
export { peopleComputerCliInventorySchema, peopleComputerConnectionSchema, peopleComputerFileAccessReadRpcInputSchema, peopleComputerFileAccessUpdateBodySchema, peopleComputerFileAccessUpdateRpcInputSchema, peopleComputerFolderPickerBodySchema, peopleComputerFolderPickerRpcInputSchema, peopleComputerProjectDiscoveryRpcInputSchema, peopleComputerSchema, peopleComputerTargetSchema, peopleComputersResponseSchema };

//# sourceMappingURL=people-computers.js.map